import { render, staticRenderFns } from "./A6Table.vue?vue&type=template&id=0b9bd9c8&scoped=true"
import script from "./A6Table.vue?vue&type=script&lang=js"
export * from "./A6Table.vue?vue&type=script&lang=js"
import style0 from "./A6Table.vue?vue&type=style&index=0&id=0b9bd9c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9bd9c8",
  null
  
)

export default component.exports